module.exports = __webpack_public_path__ + "02_mole.aaa21b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/02_mole.png
// module id = FEmY
// module chunks = 0